import styled from "styled-components";
import { ButtonQuiz } from "../../library/symbols/quizButtons";
import { motion } from "framer-motion";
import { breakpointRuleTablet } from "../../library/utilities/variables";
import React from "react";
const FirstQuestionWrapper = styled(motion.div) `
    padding-top: 52px;

    ${ButtonQuiz} {
        margin-bottom: 20px;
    }

    @media (${breakpointRuleTablet}) {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        max-width: 481px;
        margin: 0 auto;

        padding-top: 19vh;

        ${ButtonQuiz} {
            width: auto;
            margin: 0 51px 20px;
        }
    }
`;
const FirstQuestionQuestion = styled.h2 `
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 30px;
    letter-spacing: -1px;
    text-align: center;

    margin-bottom: 36px;

    @media (${breakpointRuleTablet}) {
        //styleName: Desktop/Headlines/H4 - 32pt Bold;
        font-size: 32px;
        font-weight: 700;
        line-height: 36px;

        margin-bottom: 52px;
    }

`;
export function FirstQuestionSection({ question, onQuestionAnswered }) {
    return (React.createElement(FirstQuestionWrapper, { initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 } },
        React.createElement(FirstQuestionQuestion, null, question.question),
        question.options.map(answer => React.createElement(ButtonQuiz, { key: answer.id, onClick: () => onQuestionAnswered(answer) }, answer.cta_title))));
}
